// Mock data for DMP Déménagement website
// This data is mocked for the frontend-only version. Backend integration will replace form submissions.

export const company = {
  name: "DMP Déménagement",
  logo: "https://customer-assets.emergentagent.com/job_site-cloner-138/artifacts/to2kvqry_ChatGPT%20Image%206%20juil.%202026%2C%2011_14_14.png",
  email: "diabybakary001.bd@gmail.com",
  phone: "06 98 26 95 04",
  address: "Montreuil, Île-de-France",
  tagline: "Votre déménagement, notre expertise.",
  googleReviewUrl: "https://www.google.com/maps/place/DMP+MOVING+service",
};

export const navLinks = [
  { label: "Accueil", path: "/" },
  {
    label: "Services",
    children: [
      { label: "Particuliers", path: "/particuliers", desc: "Déménagement résidentiel clé en main" },
      { label: "Professionnels", path: "/professionnels", desc: "Solutions pour entreprises" },
      { label: "Garde-meubles", path: "/garde-meubles", desc: "Stockage sécurisé courte ou longue durée" },
      { label: "Location de matériel", path: "/location-materiel", desc: "Cartons, diables, sangles..." },
      { label: "Transport d'objet", path: "/transport-objet", desc: "Objets lourds & objets d'art" },
    ],
  },
  { label: "Calculateur de volume", path: "/calculateur" },
  { label: "Contact", path: "/contact" },
];

export const hero = {
  title: "Votre déménagement,",
  titleAccent: "notre expertise",
  subtitle: "Un déménagement propre, rapide et sans stress. Particuliers et professionnels, faites confiance à une équipe qui prend soin de vos biens.",
  image: "https://images.pexels.com/photos/7464643/pexels-photo-7464643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ctaPrimary: "Demander un devis gratuit",
  ctaSecondary: "Découvrir nos services",
};

export const audienceCards = [
  {
    id: "particulier",
    title: "Je suis un particulier",
    description: "Déménagement résidentiel clé en main, de l'emballage à l'installation dans votre nouveau logement.",
    link: "/particuliers",
    image: "https://images.unsplash.com/photo-1714647211902-bb711d643a17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxtb3ZpbmclMjBjb21wYW55fGVufDB8fHx8MTc4MzMyOTU2MXww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "professionnel",
    title: "Je suis un professionnel",
    description: "Solutions de déménagement pour entreprises avec minimisation des interruptions d'activité.",
    link: "/professionnels",
    image: "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjByZWxvY2F0aW9ufGVufDB8fHx8MTc4MzMyOTYwM3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const about = {
  title: "Qui sommes-nous ?",
  paragraphs: [
    "Depuis plus de 10 ans, DMP Déménagement accompagne particuliers et professionnels avec organisation, fiabilité et humanité. Notre équipe de professionnels qualifiés met son expertise à votre service pour garantir un déménagement sans stress, qu'il s'agisse d'un appartement, d'une maison ou de bureaux professionnels.",
    "DMP est un partenaire fiable, avec une équipe engagée et proche de ses clients et partenaires.",
    "Nous nous engageons à offrir un service de qualité premium, avec des équipements modernes, une assurance complète et un accompagnement personnalisé du début à la fin de votre projet.",
  ],
  image: "https://images.pexels.com/photos/7464232/pexels-photo-7464232.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  stats: [
    { value: "10+", label: "Ans d'expérience" },
    { value: "4147+", label: "Déménagements réussis" },
    { value: "100%", label: "Clients satisfaits" },
  ],
};

export const testimonials = [
  { name: "Geneviève Antoun", location: "Montreuil", year: "2024", rating: 5, text: "Gros déménagement, meubles signés et un flipper ! Équipe discrète, très sympathique, de professionnels. Excellente évaluation du volume, respect des horaires, grand soin apporté aux divers meubles. Et en plus, un tarif très compétitif ! Félicitations et grand merci." },
  { name: "Mathilde", location: "Montreuil", year: "2024", rating: 5, text: "Les meilleurs déménageurs ! Hamza et son équipe sont hyper pro et très sympathiques. La formule tout inclus c'est la tranquillité assurée et le rapport qualité prix est imbattable ! Nous recommandons +++" },
  { name: "Celia", location: "Montreuil", year: "2024", rating: 5, text: "Déménagement d'une maison sur 3 niveaux avec des accès compliqués. Opération menée d'une main de maître par Mr Asbai et son équipe. Des personnes sérieuses, professionnelles dont la bienveillance est à souligner. Nous recommandons fortement." },
  { name: "Martin Le Thiez", location: "Montreuil", year: "2024", rating: 5, text: "Équipe ultra efficace, et très sympathique au passage. Déménagement rapide avec beaucoup de professionnalisme. Meubles protégés, déposés et remontés tel qu'on le souhaite. Je recommande fortement." },
  { name: "Frédérique Attal", location: "Montreuil", year: "2024", rating: 5, text: "Équipe très professionnelle et sympathique. Un déménagement est un moment stressant mais tout a été parfaitement anticipé et s'est déroulé comme prévu. De plus les tarifs sont compétitifs. Je recommande fortement." },
  { name: "Jean Ndeme", location: "Montreuil", year: "2024", rating: 5, text: "Des professionnels incroyables... Incontestablement. Nous avons déjà travaillé deux fois avec eux pour deux déménagements et vraiment irréprochables. Je recommande." },
];

export const homeServices = [
  { icon: "Home", title: "Déménagement résidentiel", desc: "Studios, appartements et maisons pris en charge de A à Z par nos équipes qualifiées." },
  { icon: "Building2", title: "Déménagement d'entreprise", desc: "Bureaux, commerces et locaux avec interruption minimale de votre activité." },
  { icon: "Package", title: "Emballage & protection", desc: "Cartons renforcés, housses et couvertures matelassées pour protéger vos biens." },
  { icon: "Warehouse", title: "Garde-meubles & stockage", desc: "Solutions de stockage sécurisées, courte ou longue durée selon vos besoins." },
  { icon: "Wrench", title: "Montage & démontage", desc: "Démontage et remontage de vos meubles par des professionnels expérimentés." },
  { icon: "Truck", title: "Transport sécurisé", desc: "Véhicules équipés et assurés pour un transport fiable partout en France." },
];

export const contactInfo = {
  title: "Demandez votre devis gratuit",
  subtitle: "Remplissez le formulaire ci-dessous et nous vous contacterons dans les plus brefs délais pour établir un devis personnalisé.",
};
